export const zipCodeMasks = {
  AT: '9999',
  BE: '9999',
  CH: '9999',
  CZ: '999 99',
  DE: '99999',
  DK: '9999',
  FR: '99999',
  LI: '9999',
  LU: '9999',
  NL: '9999aa',
  PL: '99-999',
} as const;
